import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import { FormArray } from '@angular/forms';
import * as moment from 'moment';
import 'moment/locale/es';  // without this line it didn't work

export class Util {

    static getIdIdioma(idioma) {
        let idIdioma;
        switch (idioma) {
            case 'es':
                idIdioma = 1;
                break;
            case 'en':
                idIdioma = 2;
                break;
            case 'port':
                idIdioma = 3;
                break;
            default:
                idIdioma = 1;
                break;
        }
        return idIdioma;
    }

    static quillGetHTML(inputDelta) {
        const jsonParse = JSON.parse(inputDelta);
        const cfg = {inlineStyles:true,encodeHtml:true};
        const converter = new QuillDeltaToHtmlConverter(jsonParse.ops, cfg);
        const html = converter.convert();
        return html;
    }

    static tiposClasificacion(parametros) {
        const categorias = [];
        const keys = Object.keys(parametros.Categoria);
        for (let index = 0; index < keys.length; index++) {
            categorias.push({ value: index + 1, nombre: parametros.Categoria[keys[index]].dato });
        }
        return categorias;
    }

    /* Funcion que obtiene los proximos 12 meses desde el mas actual */
    static getProx12Month(months) {
        const showMonths = [];
        let families = [];
        const today = new Date();
        let aMonth = today.getMonth();
        let aYear = today.getFullYear();
        for (let i = 0; i < 12; i++) {
            aMonth++;
            showMonths.push({ value: aMonth, mes: months[aMonth - 1], anio: aYear });
            if (aMonth === 12) { aMonth = 0; aYear++; }
        }
        families = Array.from(new Set(showMonths.map(({ anio }) => anio)));
        return [families, showMonths];
    }

    static eliminarDiacriticos(texto) {
        const txt = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return txt;
    }

    static changeLocale(idIdioma) {
        switch (idIdioma) {
            case 'en':
                moment.locale('en');
                break;
            case 'port':
                moment.locale('pt');
                break;
            default:
                moment.locale('es');
                break;
        }
    }

    static multipleCheckboxRequireOne(fa: FormArray) {
        let valid = false;

        for (let x = 0; x < fa.length; ++x) {
            if (fa.at(x).value) {
                valid = true;
                break;
            }
        }
        return valid ? null : {
            multipleCheckboxRequireOne: true
        };
    }
}

